module.exports = "<div class=modal tabindex=-1 role=dialog> <div class=modal-dialog> <div class=modal-content> <div class=modal-body> <div> {{ errorMessage | translate }} </div> </div> </div> </div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-invite/salary-invite/salary-invite.modal.user-conflict.html
 ** module id = 197
 ** module chunks = 0
 **/